import { useSelector } from "react-redux";

const useRule = (rules = []) => {
  const { userDetails } = useSelector((state) => state.loggedInUser);

  if (userDetails?.permissions?.length) {
    const hasPermission = rules?.some((item) =>
      userDetails.tenantRules.includes(item),
    );

    return hasPermission;
  }

  return false;
};

export default useRule;
